// extracted by mini-css-extract-plugin
module.exports = {"u-text-link":"PaidPlanRegistrationForm__u-text-link--47hQC"};